import { Database } from "@revelate/types";

type Currency = Database["public"]["Tables"]["currencies"]["Row"] | null;

export function formatCompactIsoCurrency(value: number, companyCurrency: Currency) {
  const currencyCode = companyCurrency?.code ?? "SEK";
  const absoluteValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  if (absoluteValue >= 1_000_000) {
    return `${sign}${(absoluteValue / 1_000_000).toFixed(1)} M${currencyCode}`;
  }

  if (absoluteValue >= 1_000) {
    return `${sign}${(absoluteValue / 1_000).toFixed(1)} k${currencyCode}`;
  }

  return `${sign}${absoluteValue.toFixed(absoluteValue % 1 === 0 ? 0 : 1)} ${currencyCode}`;
}
